import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
    IsChargingPipe,
    IsAvailablePipe,
    IsOccupiedPipe,
    IsPreparingPipe,
    IsFinishingPipe,
    IsUnavailablePipe,
    IsFaultedPipe,
    IsUnknownPipe,
    IsSelfTestPipe,
    IsReservedPipe,
} from './connector-status.pipe';

@NgModule({
    declarations: [
        IsChargingPipe,
        IsAvailablePipe,
        IsUnavailablePipe,
        IsFaultedPipe,
        IsOccupiedPipe,
        IsPreparingPipe,
        IsFinishingPipe,
        IsUnknownPipe,
        IsSelfTestPipe,
        IsReservedPipe,
    ],
    imports: [CommonModule],
    exports: [
        IsChargingPipe,
        IsAvailablePipe,
        IsUnavailablePipe,
        IsFaultedPipe,
        IsOccupiedPipe,
        IsPreparingPipe,
        IsFinishingPipe,
        IsUnknownPipe,
        IsSelfTestPipe,
        IsReservedPipe,
    ],
    providers: [
        IsChargingPipe,
        IsAvailablePipe,
        IsUnavailablePipe,
        IsFaultedPipe,
        IsOccupiedPipe,
        IsPreparingPipe,
        IsFinishingPipe,
        IsUnknownPipe,
        IsSelfTestPipe,
        IsReservedPipe,
    ],
})
export class ConnectorStatusPipesModule {}
